import { validateParamsRD, parsedParams, roomsTotal } from '../infrastructure/services/checkParams'

export default ({ app }, inject) => {
  const globals = {
    imageResize(url, width, height) {
      let connector = '?'
      if (url.includes('?')) {
        connector = '&'
      }
      return `${url}${connector}output-quality=70&resize=${width}:*&composite-to=center,center|${width}:${height}&background-color=white`
    },
    countdown: (maxLenght, data) => maxLenght - data.length,
    gdprCheckReplace(check) {
      const checkContent = check.content
      let checkText = checkContent.text.title
      let anchor1 = checkContent.anchor1 ? '#' + checkContent.anchor1 : ''
      let anchor2 = checkContent.anchor2 ? '#' + checkContent.anchor2 : ''
      if (checkContent.link) {
        let a;
        if (checkContent.link.modalPageId) {
          a = `<a data-pageId="${checkContent.link.modalPageId}" data-anchorId="${anchor1}" class="gdpr-modal-link">${checkContent.link.text}</a>`;
        } else if (checkContent.link.urlExterna) {
          a = `<a href="${checkContent.link.urlExterna}" class="gdpr-modal-link">${checkContent.link.text}</a>`;
        } else if (checkContent.link.linkUrl) {
          a = `<a href="${checkContent.link.linkUrl}" class="gdpr-modal-link">${checkContent.link.text}</a>`;
        }
        checkText = checkText.replace('#link1', a);
      }
      if (checkContent.link1) {
        let b;
        if (checkContent.link1.modalPageId) {
          b = `<a data-pageId="${checkContent.link1.modalPageId}" data-anchorId="${anchor2}" class="gdpr-modal-link">${checkContent.link1.text}</a>`;
        } else if (checkContent.link1.urlExterna) {
          b = `<a href="${checkContent.link1.urlExterna}" class="gdpr-modal-link">${checkContent.link1.text}</a>`;
        } else if (checkContent.link1.linkUrl) {
          b = `<a href="${checkContent.link1.linkUrl}" class="gdpr-modal-link">${checkContent.link1.text}</a>`;
        }
        checkText = checkText.replace('#link2', b);
      }
      if (checkText.includes('#modalCancelConditions')) {
        const c = `<a id="#modalCancelConditions">${app.i18n.t('lblEServicingCancelConditionsLink')}</a>`
        checkText = checkText.replace('#modalCancelConditions', c)
      }
      if(checkText.includes('#modalReservationConditions')) {
        const c = `<a id="#modalReservationConditions" class="link">${app.i18n.t('lblCOReservationConditions')}</a>`
        checkText = checkText.replace('#modalReservationConditions', c)
      }
      return checkText
    },
    linkUrl(element) {
      return typeof element.linkUrl != 'undefined' ? element.linkUrl : typeof element.urlExterna != 'undefined' ? element.urlExterna : ''
    },
    checkAndSet(val) {
      const _data = val === null ? 0 : val
      return _data
    },
    setLabel(val, singular, plural) {
      const _label = this.checkAndSet(val)
      return _label === 1 ? singular : plural
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    gotoScroll(hash, route) {
      app.router.replace({ name: route.name, query: route.query, hash }).catch(() => {})
    },
    isObjEmpty: (obj) => Object.keys(obj).length === 0,
    getCityTaxData( cityTaxesArray, hotelCityTax, hotelCity){
      try {
        const cityTaxType = hotelCityTax
        let cityTaxInfo
        const cityTaxObjects = cityTaxesArray.filter((component) => component.cityTaxCode === cityTaxType)
        if (cityTaxObjects.length > 1) {
          cityTaxObjects.forEach((component) => {
            if(component.city && component.city.description === hotelCity) {
              cityTaxInfo = component
            }
          })
          if(cityTaxInfo === undefined) {
            cityTaxObjects.forEach((component) => {
              if(!component.city) {
                cityTaxInfo = component
              }
            })
          }
        } else {
          cityTaxInfo = cityTaxObjects[0]
        }
        return (cityTaxInfo.content && cityTaxInfo.content.label && cityTaxInfo.content.label.content && cityTaxInfo.content.label.content.text) ?  cityTaxInfo.content.label.content.text : ''
      } catch (error) {
        console.log('ERROR CITYTAX')
        return ''
      }
    }
  }
  globals.validateParamsRD = validateParamsRD
  globals.parsedParams = parsedParams
  globals.roomsTotal = roomsTotal
  inject('globals', globals)
}
